import React, { Component } from 'react';

import '../styles/ScheduleLink.css';

// The way into the daily schedule, closing the rules: the schedule is what the
// daily rules leave to each day -- its size and its twists. The same sentence
// ends the rules panel and both copies of the rules modal, so a player meets it
// wherever they read the rules.
class ScheduleLink extends Component {
  render() {
    return (
      <>
        See the <button type="button" className="schedule-link" onClick={this.props.onClick}>
          daily schedule
        </button> for each day's board size and twists.
      </>
    );
  }
}

export default ScheduleLink;
